import styled from 'styled-components';

const Form = styled.form`
  margin: 55px 0;
  div + button {
    margin-top: 30px;
  }
`;

export default Form;



// WEBPACK FOOTER //
// ./src/components/Form.js